<template>
  <v-container>
    <v-row
      ><v-col>
        <div class="display-1">Hold</div>
        <div v-for="hold in classes" :key="hold.id">
          <router-link :to="`/hold/${hold.slug}`">{{ hold.name }}</router-link>
        </div>
      </v-col></v-row
    >
  </v-container>
</template>

<script>
export default {
  created() {
    this.$store.dispatch("GET_CLASSES");
    this.$store.dispatch("activePersons");
  },
  computed: {
    classes() {
      return this.$store.state.classes;
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped></style>
